<santa-tooltip
  *ngIf="state.renderTooltip && state.activeTooltipParentRef; else tooltipContent"
  [id]="state.activeTooltipParentRef"
  class="santa-cursor-default"
  [tooltipOpen]="state.showTooltip"
  [enableTooltip]="state.showTooltip"
  [tooltipContent]="tooltipTemplate"
  [tooltipPosition]="tooltipPosition"
  [tooltipOffset]="state.offset"
  allianceIntersectionObserver
  intersectionThreshold="1"
  (allianceIntersectionObservee)="setInViewState($event)"
>
  <ng-container *ngTemplateOutlet="tooltipContent"></ng-container>
</santa-tooltip>

<ng-template #tooltipContent>
  <ng-content></ng-content>
</ng-template>
